import { render, staticRenderFns } from "./SbppsParentBulkIcardPrint.vue?vue&type=template&id=7220cdcd&scoped=true&"
import script from "./SbppsParentBulkIcardPrint.vue?vue&type=script&lang=js&"
export * from "./SbppsParentBulkIcardPrint.vue?vue&type=script&lang=js&"
import style0 from "./SbppsParentBulkIcardPrint.vue?vue&type=style&index=0&id=7220cdcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7220cdcd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
